
import { Loader2 } from "lucide-react";
import { TableCell, TableRow } from "@/components/ui/table";

interface ComponentsTableStatusProps {
  loading: boolean;
  isEmpty: boolean;
}

export function ComponentsTableStatus({ loading, isEmpty }: ComponentsTableStatusProps) {
  if (loading) {
    return (
      <TableRow>
        <TableCell colSpan={5} className="text-center py-12">
          <div className="flex justify-center">
            <Loader2 className="h-6 w-6 animate-spin text-primary" />
          </div>
          <p className="mt-2 text-sm text-muted-foreground">Carregando componentes...</p>
        </TableCell>
      </TableRow>
    );
  }

  if (isEmpty) {
    return (
      <TableRow>
        <TableCell colSpan={5} className="text-center py-12">
          <p className="text-sm text-muted-foreground">Nenhum componente encontrado.</p>
        </TableCell>
      </TableRow>
    );
  }

  return null;
}
